const track = {
  deliveryNo: 'DeliveryNo',
  orderNo: 'OrderNo',
  orderType: 'OrderType',
  orderStatus: 'OrderStatus',
  factoryCode: 'ShipFactoryCode',
  carrierCode: 'CarrierCode',
  carrierName: 'Carrier',
  voucherDate: 'VoucherDate',
  route: 'Route',
  shiptoNo: 'ShipToCode',
  shiptoName: 'ShipTo',
  shipAddress: 'ShipAddress',
  totalShipQty: 'TotalShipQty',
  totalShipVolume: 'TotalShipVolume',
  pickupDate: 'PickupDate',
  expectPickupDate: 'ExpectPickupDate',
  transitTime: 'TransitTime',
  signDate: 'SignDate',
  deliveryLate: 'DeliveryLate',
  deliveryLateReason: 'DeliveryLateReason',
  deliveryLateReasonCategory: 'DeliveryLateReasonCategory',
  receiptReturnTime: 'ReceiptReturnTime',
  receiptReturnDate: 'ReceiptReturnDate',
  receiptLate: 'ReceiptLate',
  receiptLateReason: 'ReceiptLateReason',
  receiptLateReasonCategory: 'ReceiptLateReasonCategory',
  pickupPlateNo: 'PickupPlateNo',
  vehicleType: 'VehicleType',
  pickupVehicleModel: 'PickupVehicleModel',
  maxLoadVolume: 'MaxLoadVolume',
  voucherDateStart: 'VoucherDateStart',
  voucherDateEnd: 'VoucherDateEnd',
  pickupDateStart: 'PickupDateStart',
  pickupDateEnd: 'PickupDateEnd',
  signDateStart: 'SignDateStart',
  signDateEnd: 'SignDateEnd',
  orderTypePop: 'POP Order',
  orderTypeStandard: 'Standard Order',
  statusNew: 'New',
  statusShipped: 'Shipped',
  statusArrived: 'Arrived',
  statusWaitReject: 'WaitRejectConfirm',
  statusRejectDone: 'Rejected',
  delayTypeSigning: 'Signing',
  delayTypeReceipt: 'Receipt',
  vehicleInfo: 'VehicleInfo',
  msg: {}
};
export default track;



// WEBPACK FOOTER //
// ./src/page/track/lang/track.en.js